<template>
  <div class="container">
    <van-nav-bar
      v-if="!showComment"
      title="详情页"
      left-text="返回"
      right-text="主页"
      left-arrow
      @click-left="onClickLeft"
      @click-right="handleHome"
    />
    <div class="header_bar">
      <van-row class="Bar">
        <img src="@/assets/images/photodetail.png" class="title_icon" />
        <span> {{ title }}</span>
      </van-row>
      <van-cell-group class="con">
        <hr class="hr_style" />
        <van-cell :title="list.vname" title-class="cons" />
        <hr class="hr_style" />
        <van-cell title="调查单位" :value="list.vzzdw" />
        <hr class="hr_style" />
        <van-cell title="调查时间" :value="list.vkssj + '--' + list.vjssj" />
      </van-cell-group>
    </div>
    <div class="contert_bar">
      <van-row class="Bar">
        <img src="@/assets/images/write.png" class="title_icon" />
        <span> 征集说明</span>
      </van-row>
      <van-cell v-if="list.vcontent" :value="list.vcontent"/>
      <van-cell @click="viewPdf(list.fileDto)">
        <template #title>
          <span class="title_class">{{fileName}}</span>
        </template>
      </van-cell>
      <br />
      <van-form v-if="showComment">
        <van-field
          v-if="ZZDunknown || !list.unknown"
          v-model="username"
          required
          label="用户姓名"
          placeholder="请输入用户姓名"
          :disabled="ZZDdisabled"
        />
        <!-- <van-cell v-else value="当前为匿名提交意见："/> -->
        <van-field
          v-model="phone"
          required
          type="tel"
          label="手机号"
          placeholder="请输入手机号"
          :disabled="ZZDdisabled"
          :rules="[{ phone, message: '请输入手机号' }]"
        />
        <van-field
          v-if="!userAgent"
          v-model="sms"
          center
          clearable
          label="短信验证码"
          placeholder="请输入短信验证码"
        >
          <template #button>
            <van-button
              class="yzm-btn"
              size="small"
              type="primary"
              @click="sendCode"
              :disabled="disabled"
              >{{ msgCodeTxt }}</van-button
            >
          </template>
        </van-field>
      </van-form>
      <van-row class="Bar">
        <img src="@/assets/images/write.png" class="title_icon" />
        <span> 征集题目</span>
      </van-row>
      <van-form @submit="onSubmit">
        <div class="vote" v-for="(item, index) in list.votebs" :key="item.vbid">
          <!-- 单选 -->
          <div v-if="item.vmode.indexOf('单选') >= 0">
            <div class="question">{{ index + 1 }}. {{ item.vbtext }}</div>
            <van-radio-group v-model="item.danxuan" :disabled="sftx">
              <div
                class="answer"
                v-for="answer in item.votecs"
                :key="answer.vcid"
              >
                <van-radio :name="answer.vcid">{{ answer.vctitle }}</van-radio>
              </div>
            </van-radio-group>
          </div>
          <!-- 多选 -->
          <div v-if="item.vmode.indexOf('多选') >= 0">
            <div class="question">{{ index + 1 }}. {{ item.vbtext }}</div>
            <div class="mutiply">
              <van-checkbox-group v-model="item.duoxuan" :disabled="sftx">
                <div v-for="one in item.votecs" :key="one.vcid">
                  <van-checkbox
                    :name="one.vcid"
                    checked-color="#1989fa"
                    shape="square"
                  >
                    {{ one.vctitle }}
                  </van-checkbox>
                </div>
              </van-checkbox-group>
            </div>
          </div>
          <div v-if="item.vmode === '开放题'">
            <div class="question">{{ index + 1 }}. {{ item.vbtext }}</div>
            <van-field
              :disabled="sftx"
              type="textarea"
              rows="2"
              autosize
              v-model="item.text"
              placeholder="请输入内容"
            />
          </div>
        </div>
        <div class="btn" style="padding: 16px">
          <van-button
            v-if="!sftx"
            block
            type="info"
            native-type="submit"
            :disabled="submitDisabled"
            >提 交</van-button
          >
        </div>
      </van-form>
    </div>
  </div>
</template>
<script>
// import Head from '@/components/head'
import request from '@/api/getLLZ'
import dd from 'gdt-jsapi'
import zzd from '@/api/zzd.js'
import { isStringNull } from '@/utils/isvalue.js'
export default {
  // components: { Head },
  data () {
    return {
      sftx: false, // 是否填写
      llzmobile: '',
      llzname: '', // 链接中拼接mobile，username判断是不是从履职通代办中进入这个页面的
      username: '',
      phone: '',
      sms: '',
      showComment: false,
      id: '',
      title: '意见征集详情',
      openidInit: localStorage.getItem('openid'),
      // openidInit:11112222,
      postList: {
        mobile: '',
        username: '',
        vid: '',
        openid: localStorage.getItem('openid'),
        // openid:11112222
        votebs: []
      },
      list: {},
      fileName: '',
      area: '',
      getHisList: {},
      historyList: [],
      votebs: [
        {
          vmode: '单选',
          vbtext: '单选内容'
        }
      ],
      rescode: {},
      msgCodeTxt: '获取验证码',
      disabled: false,
      userAgent: '', // 判断浙政钉环境
      ZZDdisabled: false, // 浙政钉环境下的将值改为true即可
      ZZDunknown: false, // 浙政钉环境下，匿名提交的都显示
      code: '', // 浙政钉用户的code值
      submitDisabled: false// 提交后禁止再提交
    }
  },
  created () {
    this.id = this.$route.query.id
    this.llzmobile = this.$route.query.llzmobile ? this.$route.query.llzmobile : ''
    this.llzname = this.$route.query.llzname ? this.$route.query.llzname : ''
    if (this.llzmobile && this.llzname) {
      zzd.updateRead(this.$route.query.id, this.llzmobile)
    }
  },
  mounted () {
    this.initQrcode()
    this.getDetail()
    this.judgeInitWay()
  },

  methods: {
    // 浙政钉扫码进入该页面S====================
    async judgeInitWay () {
      // userAgent为true的时候是浙政钉容器
      this.userAgent = window?.navigator?.userAgent.indexOf('TaurusApp') > -1
      if (this.userAgent) {
        await this.getLoginUser()// 获取浙政钉id
        try {
          // 测试的时候用上面这个，生产打开下面的
          const res = await zzd.getZZDInfo(this.code)
          this.username = res.username
          this.phone = res.mobile
          this.ZZDdisabled = true
          this.ZZDunknown = true
        } catch (error) {
          this.$toast.fail(error)
        }
        return
      }
      // 履职通代办中进入该页面E
      if (this.llzmobile && this.llzname) {
        this.username = this.llzname
        this.phone = this.llzmobile
        this.ZZDdisabled = true// 和浙政钉环境逻辑一致
        this.userAgent = true
      }
      // 履职通代办中进入该页面S
    },
    async getLoginUser () {
      await dd.getAuthCode().then(res => {
        this.code = res?.code || res?.auth_code
      }).catch(e => e && console.error(e))
    },
    // 浙政钉扫码进入该页面E====================
    initQrcode () {
      // if(!this.openidInit){
      this.title = '意见征集'
      this.showComment = true
      // }
    },
    onClickLeft () {
      this.$router.back(-1)
    },
    handleHome () {
      this.$router.push('/home')
    },
    async onSubmit () {
      this.submitDisabled = true
      this.postList.votebs = [...this.list.votebs]
      if (this.phone || this.username) {
        this.postList.mobile = this.phone
        this.postList.username = !this.ZZDunknown && this.list.unknown ? '' : this.username
      }
      if (!this.list.unknown && !isStringNull(this.username)) {
        this.$toast.fail('请输入用户姓名')
        this.submitDisabled = false
        return
      }
      if (!isStringNull(this.phone)) {
        this.$toast.fail('请输入电话号码')
        this.submitDisabled = false
        return
      }
      for (const item of this.postList.votebs) {
        if (item.vmode.includes('多选')) {
          if (item.duoxuan === undefined || item.duoxuan.length === 0) {
            this.$toast.fail('请输入选择')
            this.submitDisabled = false
            return
          }
        }
        if (item.vmode.includes('单选') && !item.danxuan) {
          this.$toast.fail('请输入选择')
          this.submitDisabled = false
          return
        }
      }
      this.postList.vid = this.id
      if (this.openid) {
        this.postList.openid = this.openid
      }
      // 判断浙政钉扫码环境的时候，不经过这个判断
      if (!this.userAgent) {
        await request.checkCode(this.phone, this.sms)
          .then(res => {
            this.rescode = res
          })
        if (typeof this.rescode !== 'string') {
          this.$toast.fail('验证码错误')
          this.submitDisabled = false
          return
        }
      }
      try {
        this.submitDis = true
        const result = await request.addChancePeopleText(this.postList)
        if (result.data && (result.data.code === 400 || !result.data.success)) {
          this.$toast.fail(result.data.message || result.data)
        } else if (result && (result.code === 400 || result.success === false)) {
          this.$toast.fail(result.message || result)
        } else {
          this.$toast.success('提交成功！')
          this.$router.push({
            path: '/callback'
          })
        }
        this.submitDis = false
      } catch (error) {
        this.submitDis = false
        this.$toast.fail('提交失败')
        this.submitDisabled = false
      }
    },
    sendCode () {
      if (!this.phone) {
        this.$toast.fail('请输入手机号码')
        return
      }
      this.disabled = true
      request.getPhoneCode(this.phone)
        .then(res => {
          var timeStart = 60
          this.timer2 = setInterval(() => {
            if (timeStart > 0) {
              timeStart--
              this.msgCodeTxt = timeStart + 's'
            } else {
              this.disabled = false
              this.msgCodeTxt = '获取验证码'
              clearInterval(this.timer2)
            }
          }, 1000)
          this.$toast.success('发送短信成功')
        })
        .catch(() => {
          this.disabled = false
          this.$toast.fail('发送短信失败')
        })
    },
    getDetail () {
      request.getZjxqInfoOne(this.id, this.$route.query.llzmobile)
        .then(Response => {
          this.sftx = false
          this.list = Response
          this.fileName = Response.fileDto.fileName
          if (Response.dealed === '1') this.sftx = true
        })
        .catch(error => {
          console.log(error)
        })
    },
    getHistorySug () {
      this.getHisList.openid = localStorage.getItem('openid')
      // this.getHisList.openid=11112222
      this.getHisList.xmyjzjid = this.id
      request.getHistoryJy(this.getHisList)
        .then(Response => {
          this.historyList = Response.list
        })
        .catch(error => {
          console.log(error)
        })
    },
    viewPdf (item) {
      if (!item) return
      const { fileId, fileName } = item
      const fileType = fileName.split('.')
      if (fileType.includes('pdf')) {
        const url = this.$api + item.fileId
        this.$router.push({ path: '/pdfPreview', query: { file: url } })
      } else {
        this.$download('/api/common/file/download', { save: true, filename: fileName, params: { fileId } })
      }
    }
  }
}
</script>
<style lang="less" scoped>
body {
  margin: 0;
}
.title_icon {
  height: 34px;
  width: 32px;
  margin: 22px;
  margin-right: 0;
}
.container {
  background-color: #f3f8fb;
  padding-bottom: 8px;
  .header_bar,
  .foot_bar {
    margin: 20px;
    border-radius: 2px;
    background: #fff;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.08);
  }
  .header_bar {
    .con {
      font-size: 16px;
      .cons {
        font-size: 28px;
        color: rgba(0, 0, 0, 0.85);
        font-weight: 600;
      }
    }
    .contert_bar {
      margin: 20px;
      background: #fff;
      box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.08);
      .van-cell__value {
        font-family: "PingFang SC";
        font-size: 0.8rem;
        color: #323233;
        font-weight: 400;
      }
      .yzm-btn {
        width: 180px;
      }
    }
  }
  .foot_bar {
    margin-top: 0;
    .null_bar {
      font-size: 16px;
      color: #909090;
      height: 220px;
      span {
        padding: 25px;
      }
    }
    .history {
      .van-cell {
        padding: 0 25px;
      }
      .van-cell__value {
        font-size: 12px;
        font-weight: 400;
        color: #909090;
      }
    }
  }
  .btn {
    display: flex;
    justify-content: center;
    border-radius: 2px;
    .van-button {
      padding: 10px;
    }
  }
  .hr_style {
    // background: red;
    width: 90%;
    size: 1;
    opacity: 9%;
  }
}
.Bar {
  display: flex;
  align-items: center;
  height: 80px;
  margin: 0 5px;
  border-radius: 10px;
  > span {
    background: #0b0b0b;
    line-height: 0px;
    padding-left: 20px;
    font-weight: 600;
    letter-spacing: 2px;
    font-size: 32px;
    color: #0b0b0b;
  }
}
.vote {
  margin: 20px 2px;
  padding: 20px;
  border: 1px solid #e4e2e2;
  background: #fff;
  .question {
    text-indent: 2em;
    font-size: 32px;
    line-height: 45px;
    font-weight: 600;
  }
  /deep/ .van-radio {
    margin: 30px 2em;
  }
  /deep/ .van-radio__icon {
    font-size: 4.3vw;
  }
  .answer {
    margin-top: 40px;
    font-weight: 600;
    font-size: 28px;
  }
  .mutiply {
    margin-top: 40px;
    /deep/ .van-checkbox__icon .van-icon {
      border: 3px solid #a1a1a1;
      border-radius: 4px;
      width: 1em;
      height: 1em;
    }
    /deep/ .van-checkbox {
      margin: 20px 2.2em;
      font-size: 30px;
      font-weight: 600;
    }
  }
}
/deep/.van-field__word-limit {
  // background: red;
  border: 2px solid #d8d8d8;
  border-top: 1px solid rgba(0, 0, 0, 0);
  padding-right: 10px;
  margin: 0;
  background: #f7f8fa;
}
/deep/ .van-radio__icon--disabled.van-radio__icon--checked .van-icon {
    color: #1989fa;
}
/deep/ .van-checkbox__icon--disabled.van-checkbox__icon--checked .van-icon {
    color: #1989fa;
}
/deep/ .van-field__control:disabled {
    -webkit-text-fill-color: #646464;
}
.title_class{
  color: #1989fa
}
</style>
